export const DEFAULTS = {
    fontFamily: "sans-serif",
    fontWeight: "100"
}

export const COLORS = {
    primary: {
        font: "#eceff1",
        main: "#5F03F4",
        light: "#5f03f4b5",
        background: "#E2E5F0",
        shadowBox: "0px 4px 4px 0px rgba(131, 72, 255, 0.1)"
    },
};